<template>
  <v-card
    v-if="getMenuShow"
    class="d-flex flex-column align-start justify-start rounded-lg"
    :style="{ backgroundColor: item.color }"
    height="190"
    width="190"
    :to="item.to"
  >
    <div
      class="d-flex flex-column align-start justify-center pa-4"
      style="height: 100%; width: 100%"
    >
      <div
        class="mb-4"
        style="
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        "
      >
        <img
          :src="getIconSrc(item.icon)"
          alt=""
          style="width: 100%; height: 100%; object-fit: contain"
        />
      </div>
      <div
        class="text-left white--text font-weight-medium"
        style="
          word-break: break-word;
          font-size: 14px;
          line-height: 20px;
          width: 100%;
        "
        v-text="item.title"
      ></div>
    </div>
  </v-card>
</template>

<script>
import advertsIcon from '@/assets/InteractionMenu/adverts.png';
import newComersIcon from '@/assets/InteractionMenu/newComers.svg';
import bornTodayIcon from '@/assets/InteractionMenu/bornToday.svg';
import whoIsWhoIcon from '@/assets/InteractionMenu/whoIsWho.svg';
import mostIcon from '@/assets/InteractionMenu/most.svg';
import communityIcon from '@/assets/InteractionMenu/community.svg';
import thanksIcon from '@/assets/InteractionMenu/thanks.svg';
import archiveIcon from '@/assets/InteractionMenu/archive.svg';
import requestIcon from '@/assets/InteractionMenu/request.svg';
import surveyIcon from '@/assets/InteractionMenu/survey.svg';

export default {
  data() {
    return {
      iconMap: {
        'newComers.svg': newComersIcon,
        'bornToday.svg': bornTodayIcon,
        'whoIsWho.svg': whoIsWhoIcon,
        'most.svg': mostIcon,
        'community.svg': communityIcon,
        'thanks.svg': thanksIcon,
        'archive.svg': archiveIcon,
        'request.svg': requestIcon,
        'survey.svg': surveyIcon,
        'adverts.svg': advertsIcon,
      },
    };
  },
  props: {
    item: Object,
  },
  mounted() {},
  methods: {
    getIconSrc(iconName) {
      const icon = this.iconMap[iconName];
      if (!icon) {
        console.warn(`Icon not found: ${iconName}`);
        return '';
      }
      return icon.default || icon;
    },
  },
  computed: {
    getMenuShow() {
      return true;
      if (this.$store.state.user.Type.toLowerCase() != 'standart') {
        //Admin hepsini görür
        return true;
      } else if (this.$store.state.user.Type.toLowerCase() == 'standart') {
        if (!this.item.isAdmin) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
